import React from 'react';
import moment from 'moment';
import { Link } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

import { getSrc } from '../../components/UserPhoto/UserPhoto';

// {
//   "_id": "hQYL1qQe9x4IDsY102Onp",
//   "status": "active",
//   "explicit": false,
//   "processed": true,
//   "source": "device",
//   "createTime": "2019-04-08T23:16:48.975Z",
//   "images": [
//       {
//           "width": 3120,
//           "height": 4160,
//           "filename": "original.jpg",
//           "original": true
//       },
//       {
//           "width": 1200,
//           "height": 1500,
//           "filename": "XUDbDdWDle7iefN6KmwFm.webp"
//       },
//       {
//           "width": 800,
//           "height": 1000,
//           "filename": "hfC0GzA4Od1Os9wQGQCgK.webp"
//       },
//       {
//           "width": 400,
//           "height": 500,
//           "filename": "se7AlYwiZrTfvFD9Bxr6x.webp"
//       }
//   ],
//   "user": {
//       "_id": "9h1dfvwmOdCnKKr8moVnB",
//       "full": false,
//       "firstName": "Justice",
//       "lastName": "Vincent",
//       "gender": "male"
//   }
// },

const styled = withStyles(theme => {
  return {
    card: {
      width: 300,
      height: 300,
      margin: 10
    },
    media: {
      height: 240,
      backgroundSize: 'contain',
      backgroundColor: '#eee'
    },
    content: {
      padding: 10
    }
  };
});

class PhotoItem extends React.Component {
  getSrc() {
    const { user, ...photo } = this.props.data;
    const src = getSrc(
      {
        ...user,
        photos: [photo]
      },
      0
    );

    return src;
  }

  render() {
    const { classes, data } = this.props;

    const userName = data.user.firstName + ' ' + data.user.lastName;

    return (
      <Card className={classes.card}>
        <CardActionArea component={Link} to={`/users/${data.user._id}`}>
          <CardMedia
            className={classes.media}
            image={this.getSrc()}
            title={userName}
          />
          <CardContent className={classes.content}>
            <Typography>{userName}</Typography>
            <Typography variant="caption">
              {moment(new Date(data.createTime).toUTCString()).fromNow()} ({data.status})
            </Typography>
          </CardContent>
        </CardActionArea>
      </Card>
    );
  }
}

export default styled(PhotoItem);
